import { Biscuit } from "../../../utils";
import React from "react";
import HelpdeskView from "./components/HelpdeskView";

export const HelpdeskPage = (props) => {
  return (
    <>
      <>
        <HelpdeskView
          params={props.params}
          returnUrl={props.returnPath}
          dispatch={props.dispatch}
        />
      </>
    </>
  );
};
